import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from 'i18next-browser-languagedetector';

import translationEn from "./locales/en/translation.json";
import translationFr from "./locales/fr/translation.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    // lng: "fr",
    debug: true,
    detection: {
      order: ['querystring', 'cookie', 'localStorage', 'sessionStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
      // lookupQuerystring: 'lng',
    },
    keySeparator: '.', // we do not use keys in form messages.welcome
    nonExplicitSupportedLngs: true,
    supportedLngs: ["fr", "en"],
    fallbackLng: "en",
    interpolation: {
      escapeValue: false // react already safes from xss
    },
    resources: {
      en: {
        translation: translationEn
      },
      fr: {
        translation: translationFr
      }
    }
  });

export default i18n;